import {
  canNavigateToStep,
  resolveNextStepFromSession,
  type CheckoutFlowState,
} from '../CheckoutFlow.types'
import { parseCheckoutStepFromSearch } from '../checkoutUrlState'

export const buildCheckoutNextPathForLoginRedirect = (href: string): string => {
  const url = new URL(href)
  const fallback = url.pathname || '/checkout'
  const requestedStep = parseCheckoutStepFromSearch(url.search)
  if (!requestedStep) return fallback
  const nextUrl = new URL(url.pathname, url.origin)
  const queryValue =
    requestedStep === 'shipping_address'
      ? 'shipping'
      : requestedStep === 'billing_address'
        ? 'billing'
        : requestedStep === 'shipping_method'
          ? 'shipping-method'
          : requestedStep === 'review'
            ? 'review'
            : requestedStep === 'redirecting_to_payment' || requestedStep === 'completed'
              ? 'payment'
              : ''
  if (queryValue) {
    nextUrl.searchParams.set('step', queryValue)
  }
  return `${nextUrl.pathname}${nextUrl.search}`
}

export const readLegacySessionIdFromSearch = (): string | null => {
  if (typeof window === 'undefined') return null
  const params = new URLSearchParams(window.location.search)
  const id = params.get('sessionId') ?? params.get('session')
  if (!id) return null
  const normalized = id.trim()
  if (!normalized) return null
  return /^[a-f0-9]{24}$/i.test(normalized) ? normalized : null
}

export const resolveStepFromPopstate = ({
  session,
  fallbackStep,
}: {
  session: CheckoutFlowState['session']
  fallbackStep: ReturnType<typeof resolveNextStepFromSession>
}) => {
  if (typeof window === 'undefined' || !session) return fallbackStep
  const requestedStep = parseCheckoutStepFromSearch(window.location.search)
  if (!requestedStep) return fallbackStep
  if (!canNavigateToStep(session, requestedStep)) return fallbackStep
  return requestedStep
}
